import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"
import editIcon from "../../assets/icon/edit.svg"
import trashIcon from "../../assets/icon/trash.svg"
import ParseDate from "../../tools/ParseDate"
import {useTranslation} from "react-i18next"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import arrowLeftIcon from "../../assets/icon/arrow-left.svg"
import {useNavigate} from "react-router-dom"

export default function TeamDashboardHeader({team}) {
    const {t} = useTranslation()
    const {setNwDashboardAction} = useNwDashboardContext()
    const navigate = useNavigate()

    const deleteTeam = () => {
        setNwDashboardAction({type: "NW_DASHBOARD_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: team.id, action: "delete"}}})
    }

    const updateTeam = () => {
        setNwDashboardAction({type: "NW_DASHBOARD_IS_MODAL", payload: {isModal: true}})
    }

    const previousPage = () => {
        navigate(-1)
    }

    if (!team) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION TEAM-DASHBOARD-HEADER">
            <span>
                <h1>{team.name}</h1>
                <img src={editIcon} alt="" onClick={updateTeam}/>
                <img src={trashIcon} alt="" onClick={deleteTeam}/>
                <p>{ParseDate(team.licence_start_date)} {t("at")} {ParseDate(team.licence_end_date)}</p>
            </span>
            <button className="previous-btn" onClick={previousPage} title={t("Previous page")}><img src={arrowLeftIcon} alt=""/></button>
        </div>
        </>
    )
}